import React from 'react';
import Slide from '@mui/material/Slide';
export const CustomTransition = React.forwardRef(function Transition(props, ref) {
    return React.createElement(Slide, Object.assign({ direction: "up", ref: ref }, props));
});
